// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
// Vue.prototype.HOST = 'http://admin.siisoo.com:9999' // zx
Vue.prototype.HOST = 'https://admin.siisoo.com' // zx
Vue.prototype.HOST_NEW = 'https://www.siisoo.com' // zx
// Vue.prototype.HOST = 'http://132.232.65.47:10010' // zx
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)

})



// WEBPACK FOOTER //
// ./src/main.js